export class ProductAnalysisReq{
    fromDate: any
    toDate: any
    constructor(fromDate:any,toDate:any){
        this.fromDate = fromDate
        this.toDate = toDate
    }
}

export class ProductSummaryReportReq{
    month: number
    year: number
    varientId:number
    packStyleId:number
    constructor(month:number,year:number,varientId:number,
        packStyleId:number){
        this.month = month
        this.year = year
        this.varientId=varientId
        this.packStyleId=packStyleId
    }
}